// extracted by css-extract-rspack-plugin
var _1 = "Rb48Jpr9FMCrhpW2i9mrEg--";
var _2 = "_2KdMGN4A6RzWnqQW5kj9-g--";
export { _1 as "badge", _2 as "container" }
